import { Spin } from 'antd';
import Editor from '../Editor';

export default function EditorWrapper({ isSaving, setIsSaving }) {
  return (
    <Spin
      spinning={isSaving}
      tip="Speichern…"
      size="large"
      style={{ width: '100vw', height: '100vh' }}
    >
      <Editor setIsSaving={setIsSaving} />
    </Spin>
  );
}
